// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slide-but * {
  box-sizing: border-box;
}

.slide-but {
  height: 40px;
  border: 1px solid #8D94A4;
  min-width: 200px;
  padding: 11px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  user-select: none;
  border-radius: 8px;
}
.slide-but span {
  color: #8D94A4;
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.slide-but * {
  pointer-events: none;
  user-select: none;
}

.slide-but .slide-overlay {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  height: 100%;
  width: 2rem;
  background: #E42A23;
  transition: width 0.2s ease-out;
  will-change: width;
  overflow: hidden;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  box-shadow: -1px 0px 4px 0px rgba(0, 0, 0, 0.25);
}

.slide-but .slide-overlay .slide-overlay-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  border-radius: 8px;
  box-shadow: -1px 0px 4px 0px rgba(0, 0, 0, 0.25);
}

.slide-but .slide-overlay .slide-caret-wrapper {
  position: absolute;
  border-radius: 8px;
  max-width: 45px;
  min-width: 0;
  right: 0;
  top: 50%;
  height: 100%;
  transform: translateY(-50%);
  background: #E42A23;
  z-index: 2;
  display: flex;
  align-items: center;
  padding: 10px;
  justify-content: center;
  box-shadow: -1px 0px 4px 0px rgba(0, 0, 0, 0.25);
}

.slide-but .slide-overlay .slide-overlay-txt {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  height: 100%;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/infraestructure/styles/swipeable-button.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;AACJ;;AACE;EACE,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAEJ;AADI;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAGN;;AAAE;EACE,oBAAA;EACA,iBAAA;AAGJ;;AADE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gDAAA;AAIJ;;AAFE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gDAAA;AAKJ;;AAHE;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,QAAA;EACA,YAAA;EACA,2BAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,gDAAA;AAMJ;;AAHE;EACE,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAMJ","sourcesContent":[".slide-but * {\n    box-sizing: border-box;\n  }\n  .slide-but {\n    height: 40px;\n    border: 1px solid #8D94A4;\n    min-width: 200px;\n    padding: 11px;\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: default;\n    user-select: none;\n    border-radius: 8px;\n    span {\n      color:  #8D94A4;\n      text-align: center;\n      font-family: Roboto;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 24px; \n    }\n  }\n  .slide-but * {\n    pointer-events: none;\n    user-select: none;\n  }\n  .slide-but .slide-overlay {\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: 1;\n    height: 100%;\n    width: 2rem;\n    background: #E42A23;\n    transition: width 0.2s ease-out;\n    will-change: width;\n    overflow: hidden;\n    pointer-events: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 8px;\n    box-shadow: -1px 0px 4px 0px rgba(0, 0, 0, 0.25);\n  }\n  .slide-but .slide-overlay .slide-overlay-wrapper {\n    position: relative;\n    height: 100%;\n    width: 100%;\n    border-radius: 8px;\n    box-shadow: -1px 0px 4px 0px rgba(0, 0, 0, 0.25);\n  }\n  .slide-but .slide-overlay .slide-caret-wrapper {\n    position: absolute;\n    border-radius: 8px;\n    max-width: 45px;\n    min-width: 0;\n    right: 0;\n    top: 50%;\n    height: 100%;\n    transform: translateY(-50%);\n    background: #E42A23;\n    z-index: 2;\n    display: flex;\n    align-items: center;\n    padding: 10px;\n    justify-content: center;\n    box-shadow: -1px 0px 4px 0px rgba(0, 0, 0, 0.25);\n    \n  }\n  .slide-but .slide-overlay .slide-overlay-txt {\n    position: absolute;\n    width: 100%;\n    left: 0;\n    top: 0;\n    height: 100%;\n    color: #fff;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    white-space: nowrap;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
